module.exports = __webpack_public_path__ + "img/remote-assistence.4abd68b4.svg";